import { Container, Flex, Text } from "@chakra-ui/react";
import { Divider, ExperienceTile, Footer, Tabs, TripBox, TripTile } from "components";
import { EXPERIENCE_TILE, TRIPS_DEMO, TRIP_TILE } from "data";
import { Itinerary } from "./Itinerary";

const TripItinerary = () => {
    const tabList = [{
        id: 1,
        title: 'Itinerary',
        content:<Itinerary />
      },
      {
        id: 2,
        title: 'Stays',
        content: <></>
      },
      {
        id: 3,
        title: 'Tickets',
        content:  <></>
      },
      {
        id: 4,
        title: 'Experiences',
        content:  <></>
      }];

    return (
        <>
            <Container maxWidth='45%'>
                <TripBox data={TRIPS_DEMO[0]} />
                <Tabs tabList={tabList} variant='line' unstyled />
                <Text fontWeight={600} marginBottom={3} fontSize='18px'>Monday, 19 Sep</Text>
                <Flex marginBottom={3}>
                <Divider width='10%' orientation="vertical" />
                </Flex>
                <TripTile isFlight data={TRIP_TILE}/>
                <Flex marginTop={3}>
                    <Divider width='10%' orientation="vertical" />
                </Flex>
                <Text fontWeight={600} marginTop={3} marginBottom={3} fontSize='18px'>Monday, 19 Sep</Text>
                <Divider width='10%' orientation="vertical" />
                <Flex marginTop={3}>
                    <ExperienceTile data={EXPERIENCE_TILE} />
                </Flex>
                <Flex marginTop={3} marginBottom={3}>
                    <Divider width='10%' orientation="vertical" />
                </Flex>
                <TripTile isFlight data={TRIP_TILE}/>
            </Container>
            <Footer />
        </>
    );
  };
  
  export { TripItinerary };
  